<template>
  <div>
    <v-dialog v-model="editWorktimeDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ editDialogLabel }}打刻修正
          <v-spacer></v-spacer>
          <v-btn icon @click="editWorktimeDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <input-hour-min v-model="editUnixtime" />
          <v-layout row wrap>
            <v-flex md12>
              <v-textarea
                label="修正理由"
                v-model="editReasons"
                :rows="2"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-alert
            :value="editWorktimeErrors.length > 0"
            color="error"
            outline
            >{{ editWorktimeErrors }}</v-alert
          >
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue"
            class="white--text"
            @click="editWorktimeDialog = false"
            >キャンセル</v-btn
          >
          <v-btn color="blue" class="white--text" @click="saveItem">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-layout row wrap justify-end v-if="!readOnly">
        <v-btn @click="addItem('office')" color="blue" class="white--text">
          出社勤務追加
        </v-btn>
        <v-btn @click="addItem('home')" color="green" class="white--text">
          在宅勤務追加
        </v-btn>
      </v-layout>
      <table>
        <colgroup>
          <col style="width: 10%" />
          <col style="width: 25%" />
          <col style="width: 10%" />
          <col style="width: 25%" />
          <col style="width: 10%" />
          <col style="width: 10%" v-if="!readOnly"/>
        </colgroup>
        <thead>
          <tr>
            <th>種別</th>
            <th colspan="2">始業</th>
            <th colspan="2">終業</th>
            <th v-if="!readOnly">削除</th>
          </tr>
        </thead>
        <tr v-for="(item, i) in hours" :key="i" style="text-align: center">
          <td>
            {{ item.type }}
          </td>

          <td>
            <input-time
              v-model="item.start"
              :readonly="true"
              v-if="item.start"
            />
            <div v-else>未入力</div>
            <div v-if="item.reasonsForEditStart">
              修正理由：{{ item.reasonsForEditStart }}
            </div>
          </td>
          <td>
            <v-btn icon :disabled="readOnly">
              <v-icon @click="editItem(i, 'start')">edit</v-icon>
            </v-btn>
          </td>
          <td>
            <input-time v-model="item.end" :readonly="true" v-if="item.end" />
            <div v-else>未入力</div>
            <div v-if="item.reasonsForEditEnd">
              修正理由：{{ item.reasonsForEditEnd }}
            </div>
          </td>
          <td>
            <v-btn icon :disabled="readOnly">
              <v-icon @click="editItem(i, 'end')">edit</v-icon>
            </v-btn>
          </td>
          <td v-if="!readOnly">
            <v-btn icon>
              <v-icon @click="deleteItem(i)">delete</v-icon>
            </v-btn>
          </td>
        </tr>
        <tr></tr>
      </table>
      <v-alert
        outline
        :value="true"
        color="info"
        style="width: 80%"
        v-if="itemsIsNothing"
        >保存済の勤怠はありません。
      </v-alert>
    </v-layout>
  </div>
</template>
<script>
import InputHourMin from "@/components/inputHourMin";
import InputTime from "@/components/inputTime";
export default {
  components: {
    InputHourMin,
    InputTime,
  },
  props: {
    hours: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newItem: {
        office: {
          start: null,
          end: null,
          type: "出社",
          reasonsForEditStart: "",
          reasonsForEditEnd: "",
          isEditWorktime: false,
        },
        home: {
          start: null,
          end: null,
          type: "在宅",
          reasonsForEditStart: "",
          reasonsForEditEnd: "",
          isEditWorktime: false,
        },
      },
      startOrEnd: "start",
      editDialogLabel: "出勤",
      editWorktimeDialog: false,
      editUnixtime: null,
      editReasons: "",
      editIndex: null,
      editWorktimeErrors: "",
    };
  },
  mounted() {
    this.sortItems();
  },
  methods: {
    addItem(workplace) {
      this.hours.push({ ...this.newItem[workplace] });
    },
    editItem(index, startOrEnd) {
      this.startOrEnd = startOrEnd;
      this.editIndex = index;
      this.editDialogLabel =
        this.hours[index].type +
        (startOrEnd == "start" ? "出勤" : "退勤") +
        "時間";
      this.editUnixtime = this.hours[index][startOrEnd];
      this.editWorktimeDialog = true;
      this.editReasons =
        startOrEnd == "start"
          ? this.hours[index].reasonsForEditStart
          : this.hours[index].reasonsForEditEnd;
    },
    deleteItem(index) {
      this.hours.splice(index, 1);
    },
    saveItem() {
      if (this.editReasons.length > 0) {
        this.editWorktimeErrors = "";
        const item = this.hours[this.editIndex];

        item.isEditWorktime = true;
        item[this.startOrEnd] = this.editUnixtime;
        if (this.startOrEnd == "start") {
          item.reasonsForEditStart = this.editReasons;
        } else {
          item.reasonsForEditEnd = this.editReasons;
        }
        this.$set(this.hours, this.editIndex, item);
        this.sortItems();
        this.$emit("updateItems");
        this.editWorktimeDialog = false;
      } else {
        this.editWorktimeErrors = "修正理由を入力してください。";
      }
    },
    sortItems() {
      this.hours = this.hours.sort((a, b) => {
        if (a.start < b.start) return -1;
        if (a.start > b.start) return 1;
        return 0;
      });
    },
  },
  computed: {
    itemsIsNothing() {
      return this.hours.length == 0;
    },
  },
};
</script>


<style lang="scss" scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgba(0, 0, 0, 0.12);
  table-layout: fixed;
  font-size: 9pt;
  width: 100%;
  tr,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid gray;
  }
  td {
    word-wrap: break-word;
    padding: 5pt;
  }
  tr {
  }
  td.delete-cell {
    text-align: center;
    padding: 0px;
  }
}
</style>